"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Renders the Excel icon
 * @param {React.SVGProps<SVGSVGElement>} props - The props for the Excel component
 * @returns {JSX.Element} - The Excel component
 * @example
 * <Excel />
 * @example
 * <Excel height={24} width={24} />
 * @example
 * <Excel className="custom-class" />
 */
function Excel({ isDecorative, ...props }) {
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        react_1.default.createElement("path", { d: "M14.1716 2.5H6C5.17157 2.5 4.5 3.17157 4.5 4V20C4.5 20.8284 5.17157 21.5 6 21.5H18C18.8284 21.5 19.5 20.8284 19.5 20V7.82843C19.5 7.16539 19.2366 6.5295 18.7678 6.06066L15.9393 3.23223C15.4705 2.76339 14.8346 2.5 14.1716 2.5Z", fill: "#E7E7E7", stroke: "#BCBCBC" }),
        react_1.default.createElement("path", { d: "M14.5 3V6.5C14.5 7.05228 14.9477 7.5 15.5 7.5H19", stroke: "#BCBCBC" }),
        react_1.default.createElement("rect", { y: "8", width: "12", height: "12", rx: "2", fill: "#4FAD6F" }),
        react_1.default.createElement("path", { d: "M3.5 11.5L8.5 16.5", stroke: "white", strokeLinecap: "round" }),
        react_1.default.createElement("path", { d: "M8.5 11.5L3.5 16.5", stroke: "white", strokeLinecap: "round" }),
        !isDecorative && react_1.default.createElement("title", null, "excel doc icon")));
}
exports.default = Excel;
